export const SEO_NO_MEDIUM_KEY = 'noMedium';
export const SEO_NO_LAYOUT_KEY = 'noLayout';
export const SEO_MULTIPLE_KEY = 'multiple';
export const SEO_CANVAS_KEY = 'canvas';
export const SEO_FRAMED_CANVAS_KEY = 'framed canvas';
export const SEO_FRAMED_PRINT_KEY = 'framed print';
export const SEO_POSTER_PRINT_KEY = 'poster print';
export const SEO_ART_PRINT_KEY = 'art print';
export const seoGetKeywords = ({ layoutKey = SEO_NO_LAYOUT_KEY, mediumKey = SEO_NO_MEDIUM_KEY }) => {
    switch (mediumKey) {
        case 'painting':
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Paintings', 'Art Prints', 'painting prints'];
                case SEO_CANVAS_KEY: return ['Canvas Paintings', 'Art Prints', 'canvas art'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Paintings', 'Art Prints', 'canvas paintings'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Paintings', 'Art Prints', 'wall art paintings'];
                case SEO_POSTER_PRINT_KEY: return ['Wall Posters', 'Art Prints', 'painting art'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'print painting'];
                default: return ['Paintings', 'Wall Art', 'art'];
            }
        case 'drawing':
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Drawings', 'Artwork', 'drawings'];
                case SEO_CANVAS_KEY: return ['Canvas Drawings', 'Artwork', 'artwork'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Drawings', 'Artwork', 'wall art drawings'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Print Drawings', 'Artwork', 'art sketches'];
                case SEO_POSTER_PRINT_KEY: return ['Poster Print', 'Artwork', 'art drawings'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'art print drawing'];
                default: return ['Drawings', 'Wall Art', 'art'];
            }
        case 'digital-art':
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Digital Art', 'Pictures', 'prints'];
                case SEO_CANVAS_KEY: return ['Canvas Digital Art', 'Pictures', 'canvas wall art'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Digital Art', 'Pictures', 'canvas prints'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Print Digital Art', 'Pictures', 'art prints'];
                case SEO_POSTER_PRINT_KEY: return ['Digital Art Posters', 'Pictures', 'art'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'mat print'];
                default: return ['Digital Art', 'Wall Art', 'art'];
            }
        case 'photography':
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Photographs', 'Wall Prints', 'photographs'];
                case SEO_CANVAS_KEY: return ['Canvas Photographs', 'Wall Prints', 'art photography'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Photographs', 'Wall Prints', 'photography prints'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Photographs', 'Wall Prints', 'wall art photography'];
                case SEO_POSTER_PRINT_KEY: return ['Poster Art', 'Wall Prints', 'photo art'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'photo art print'];
                default: return ['Photographs', 'Wall Art', 'art'];
            }
        case 'graffiti':
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Graffiti Art', 'Prints', 'prints'];
                case SEO_CANVAS_KEY: return ['Canvas Graffiti Art', 'Prints', 'canvas wall art'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Graffiti Art', 'Prints', 'canvas prints'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Print Graffiti Art', 'Prints', 'art prints'];
                case SEO_POSTER_PRINT_KEY: return ['Art Posters', 'Prints', 'art'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'graffiti art'];
                default: return ['Graffiti', 'Wall Art', 'art'];
            }
        case 'watercolor':
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Watercolor', 'Art', 'prints'];
                case SEO_CANVAS_KEY: return ['Canvas Watercolor', 'Art', 'canvas wall art'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Watercolor', 'Art', 'canvas prints'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Print Watercolor', 'Art', 'art prints'];
                case SEO_POSTER_PRINT_KEY: return ['Watercolor Posters', 'Art', 'art'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'watercolor art print'];
                default: return ['Watercolor', 'Wall Art', 'art'];
            }
        case 'printmaking':
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Printmaking', 'Art', 'printmaking'];
                case SEO_CANVAS_KEY: return ['Canvas Printmaking', 'Art', 'printmaking'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Printmaking', 'Art', 'printmaking'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Print Printmaking', 'Art', 'printmaking'];
                case SEO_POSTER_PRINT_KEY: return ['Printmaking Posters', 'Art', 'printmaking'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'art printmaking'];
                default: return ['Printmaking', 'Wall Art', 'art'];
            }
        default:
            switch (layoutKey) {
                case SEO_MULTIPLE_KEY: return ['Multi Panel Art', 'Prints', 'prints'];
                case SEO_CANVAS_KEY: return ['Canvas Wall Art', 'Prints', 'canvas wall art'];
                case SEO_FRAMED_CANVAS_KEY: return ['Framed Canvas Prints', 'Art Prints', 'canvas prints'];
                case SEO_FRAMED_PRINT_KEY: return ['Framed Prints', 'Pictures', 'art prints'];
                case SEO_POSTER_PRINT_KEY: return ['Posters', 'Prints', 'art'];
                case SEO_ART_PRINT_KEY: return ['Art Print', 'Art', 'print'];
                case 'canvas wall display': return ['Canvas Wall Display', 'Photo Print', 'Personalized'];
                case 'photo collage': return ['Photo Print Gallery', 'Photo Print', 'Personalized'];
                case 'tiles': return ['Photo Print Tiles', 'Photo Print', 'Personalized'];
                default: return ['Wall Art', '', 'art'];
            }
    }
};
